import { httpFetch } from '../Utils/httpUtils';
import { customerActionTypes } from '../ActionTypes/customerActionTypes';
import commonActions from './commonActions';

const educationActions = {
    getEducationServices(customerId, callback) {
        return (dispatch) => {
            return httpFetch(`/api/Education/GetEducationServices/${customerId}`, dispatch)
                .then((json) => {
                    callback(json);
                })
                .catch((error) => {
                    dispatch(commonActions.showError('Failed to fetch education services.'));
                    callback(null);
                });
        };
    },

    createEducationCode(customerId, selectedServiceIds, callback) {
        return (dispatch) => {
            dispatch(commonActions.progressLoader(true));

            var object = {
                customerId: customerId,
                serviceIds: selectedServiceIds,
            };

            const httpRequest = {
                method: 'POST',
                body: JSON.stringify(object),
            };

            return httpFetch('/api/Education/CreateEducationCode', dispatch, httpRequest)
                .then((json) => {
                    dispatch(commonActions.progressLoader(false));
                    dispatch(commonActions.showSuccess('Education code created successfully!'));

                    dispatch({
                        type: customerActionTypes.UPDATE_VON_CUSTOMER_EDUCATION_LICENSE,
                        data: json.educationLicenseCode,
                    });

                    callback();
                })
                .catch((error) => {
                    dispatch(commonActions.showError('Failed to create education code.'));
                    dispatch(commonActions.progressLoader(false));
                });
        };
    },
};

export default educationActions;
